import { createAsyncThunk } from "@reduxjs/toolkit";

import apiRequest from "../../../services/api";

export const userReportData = createAsyncThunk(
  "reports/user_tracker/userReportData",
  async (body) => {
    const verifyDetails = await apiRequest.get(`v1/reports/${body.e}/`, {
      headers: { organization: body.userOrganization.org_id },
    });
    return verifyDetails.data;
  }
);

export const exportTrackerDataReport = createAsyncThunk(
  "reports/user_tracking_report/export/ExportTrackerDataReport",
  async (body) => {
    const verifyDetails = await apiRequest.get(
      `v1/reports/user_tracking_report/export/`,
      {
        headers: { organization: body.userOrganization.org_id },
      }
    );
    return verifyDetails.data;
  }
);

export const providerScoreCardQuestionAccuracyReport = createAsyncThunk(
  "reports/provider_scorecard/questionAccuracyReport",
  async (body, thunkAPI) => {
    let query = `page=${body.page ? body.page : 1}`;
    if (body.page_size) {
      query = query + `&page_size=${body.page_size}`;
    }
    if (body.period) {
      query = query + `&period=${body.period}`;
    }
    if (body.type) {
      query = query + `&type=${body.type}`;
    }
    const verifyDetails = await apiRequest
      .get(`v1/provider_scorecard/question_accuracy/dashboard/?${query}`, {
        headers: { organization: body.userOrganization.org_id },
      })
      .catch((e) => {
        throw thunkAPI.rejectWithValue(e.response.data);
      });
    return verifyDetails.data;
  }
);

export const providerScoreCardQuestionAnsweredReport = createAsyncThunk(
  "reports/provider_scorecard/questionAnsweredReport",
  async (body, thunkAPI) => {
    let query = `page=${body.page ? body.page : 1}`;
    if (body.page_size) {
      query = query + `&page_size=${body.page_size}`;
    }
    if (body.period) {
      query = query + `&period=${body.period}`;
    }
    if (body.type) {
      query = query + `&type=${body.type}`;
    }
    const verifyDetails = await apiRequest
      .get(`v1/provider_scorecard/question_answered/dashboard/?${query}`, {
        headers: { organization: body.userOrganization.org_id },
      })
      .catch((e) => {
        throw thunkAPI.rejectWithValue(e.response.data);
      });
    return verifyDetails.data;
  }
);

export const providerScoreCardContestParticipationReport = createAsyncThunk(
  "reports/provider_scorecard/contestParticipationReport",
  async (body, thunkAPI) => {
    let query = `page=${body.page ? body.page : 1}`;
    if (body.page_size) {
      query = query + `&page_size=${body.page_size}`;
    }
    if (body.period) {
      query = query + `&period=${body.period}`;
    }
    if (body.type) {
      query = query + `&type=${body.type}`;
    }
    const verifyDetails = await apiRequest
      .get(`v1/provider_scorecard/contest_participation/dashboard/?${query}`, {
        headers: { organization: body.userOrganization.org_id },
      })
      .catch((e) => {
        throw thunkAPI.rejectWithValue(e.response.data);
      });
    return verifyDetails.data;
  }
);

export const providerScoreCardAnnualCertificationReport = createAsyncThunk(
  "reports/provider_scorecard/annualCertificationReport",
  async (body, thunkAPI) => {
    let query = `page=${body.page ? body.page : 1}`;
    if (body.page_size) {
      query = query + `&page_size=${body.page_size}`;
    }
    if (body.period) {
      query = query + `&period=${body.period}`;
    }
    if (body.type) {
      query = query + `&type=${body.type}`;
    }
    const verifyDetails = await apiRequest
      .get(`v1/provider_scorecard/annual_certification/dashboard/?${query}`, {
        headers: { organization: body.userOrganization.org_id },
      })
      .catch((e) => {
        throw thunkAPI.rejectWithValue(e.response.data);
      });
    return verifyDetails.data;
  }
);

export const providerScoreCardVideosWatchedReport = createAsyncThunk(
  "reports/provider_scorecard/videosWatchedReport",
  async (body, thunkAPI) => {
    let query = `page=${body.page ? body.page : 1}`;
    if (body.page_size) {
      query = query + `&page_size=${body.page_size}`;
    }
    if (body.period) {
      query = query + `&period=${body.period}`;
    }
    if (body.type) {
      query = query + `&type=${body.type}`;
    }
    const verifyDetails = await apiRequest
      .get(`v1/provider_scorecard/videos_watched/dashboard/?${query}`, {
        headers: { organization: body.userOrganization.org_id },
      })
      .catch((e) => {
        throw thunkAPI.rejectWithValue(e.response.data);
      });
    return verifyDetails.data;
  }
);

export const providerScoreCardArticlesReadReport = createAsyncThunk(
  "reports/provider_scorecard/articlesReadReport",
  async (body, thunkAPI) => {
    let query = `page=${body.page ? body.page : 1}`;
    if (body.page_size) {
      query = query + `&page_size=${body.page_size}`;
    }
    if (body.period) {
      query = query + `&period=${body.period}`;
    }
    if (body.type) {
      query = query + `&type=${body.type}`;
    }
    const verifyDetails = await apiRequest
      .get(`v1/provider_scorecard/articles_read/dashboard/?${query}`, {
        headers: { organization: body.userOrganization.org_id },
      })
      .catch((e) => {
        throw thunkAPI.rejectWithValue(e.response.data);
      });
    return verifyDetails.data;
  }
);

export const providerScoreCardProgramsCompletedReport = createAsyncThunk(
  "reports/provider_scorecard/programsCompletedReport",
  async (body, thunkAPI) => {
    let query = `page=${body.page ? body.page : 1}`;
    if (body.page_size) {
      query = query + `&page_size=${body.page_size}`;
    }
    if (body.period) {
      query = query + `&period=${body.period}`;
    }
    if (body.type) {
      query = query + `&type=${body.type}`;
    }
    const verifyDetails = await apiRequest
      .get(`v1/provider_scorecard/programs_completed/dashboard/?${query}`, {
        headers: { organization: body.userOrganization.org_id },
      })
      .catch((e) => {
        throw thunkAPI.rejectWithValue(e.response.data);
      });
    return verifyDetails.data;
  }
);

export const clinicalPerformanceReport = createAsyncThunk(
  "reports/provider_scorecard/clicalPerformanceReport",
  async (body, thunkAPI) => {
    let query = `page=${body.page ? body.page : 1}`;
    if (body.page_size) {
      query = query + `&page_size=${body.page_size}`;
    }
    if (body.period) {
      query = query + `&period=${body.period}`;
    }
    if (body.version) {
      query = query + `&version=${body.version}`;
    }
    if (body.type) {
      query = query + `&type=${body.type}`;
    }
    if (body.ordering) {
      query = query + `&ordering=${body.ordering}`;
    }
    const response = await apiRequest
      .get(`v1/provider_scorecard/reports/clinics/?${query}`, {
        headers: { organization: body.userOrganization.org_id },
      })
      .catch((e) => {
        throw thunkAPI.rejectWithValue(e.response.data);
      });
    return response.data;
  }
);

export const clinicLevelPerformanceReport = createAsyncThunk(
  "reports/provider_scorecard/clinicLevelPerformanceReport",
  async (body, thunkAPI) => {
    let query = `page=${body.page ? body.page : 1}`;
    if (body.page_size) {
      query = query + `&page_size=${body.page_size}`;
    }
    if (body.period) {
      query = query + `&period=${body.period}`;
    }
    if (body.type) {
      query = query + `&type=${body.type}`;
    }
    if (body.version) {
      query = query + `&version=${body.version}`;
    }
    if (body.clinic_name) {
      query = query + `&clinic_name=${body.clinic_name}`;
    }
    if (body.ordering) {
      query = query + `&ordering=${body.ordering}`;
    }
    const response = await apiRequest
      .get(`v1/provider_scorecard/reports/clinics/users/?${query}`, {
        headers: { organization: body.userOrganization.org_id },
      })
      .catch((e) => {
        throw thunkAPI.rejectWithValue(e.response.data);
      });
    return response.data;
  }
);

// Organisation reports
export const getOrganisationAvailableReports = createAsyncThunk(
  "reports/available_reports/organisation_available_reports",
  async (body, thunkAPI) => {
    const response = await apiRequest
      .get(`v2/looker_report/mappings/`, {
        headers: { organization: body.userOrganization.org_id },
      })
      .catch((e) => {
        throw thunkAPI.rejectWithValue(e.response.data);
      });
    return response.data;
  }
);

export const getReportUrlFromName = createAsyncThunk(
  "reports/available_reports/get_report_url_from_name",
  async (body, thunkAPI) => {
    const response = await apiRequest
      .get(`v2/looker_report/embed_url/?name=${body.name}`, {
        headers: { organization: body.userOrganization.org_id },
      })
      .catch((e) => {
        throw thunkAPI.rejectWithValue(e.response.data);
      });
    return response.data;
  }
);
